import React from 'react'
import AuthNavbar from '../components/AuthNavbar/AuthNavbar'
import HomeTitle from '../components/HomeTitle/HomeTitle'
import EditeProfileForm from '../components/EditeProfileForm/EditeProfileForm'
import EditeStudentFormContainer from '../components/EditeStudentFormContainer/EditeStudentFormContainer'
import { useSelector } from 'react-redux';
import RegisterationStudentContaier from '../components/RegisterationStudentContaier/RegisterationStudentContaier';
import { Container } from 'react-bootstrap';

function EditeProfile() {
    const { currentLocal } = useSelector((state) => state.currentLocal);
    const userinfo = useSelector((state) => state.auth?.userArray?.user);

    return (
        <div>
            <AuthNavbar />
            <HomeTitle title={currentLocal.home.profile} />
            {userinfo?.role=="Student"?
<Container>
                <EditeStudentFormContainer
    />
</Container>

          :
                      <EditeProfileForm />

          
          }
        </div>
    )
}

export default EditeProfile
